import React, { useCallback, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import './tabs.scss'

const Tab = ({ index, name, activeTab, changeActiveTab }) => {
	return (
		<li
			className={index === activeTab && 'is-active'}
			onClick={() => index !== activeTab && changeActiveTab(index)}
		>
			<a>
				<span dangerouslySetInnerHTML={{ __html: name }} />
			</a>
		</li>
	)
}

export default function Tabs({
	onTabsChange,
	titles,
	id,
	currentActiveTabs,
	datas,
	tabsClassName,
	className
}) {
	const [activeTab, setActiveTab] = useState(currentActiveTabs)
	const changeActiveTab = useCallback(function (name) {
		setActiveTab(name)
		onTabsChange && onTabsChange()
	}, [])

	const timeout = { enter: 1200, exit: 500 }

	return (
		<div className="container">
			<div
				id={id ? id : ''}
				name={id ? id : ''}
				className={`o__tabs is-toggle is-toggle-rounded ${
					tabsClassName ? tabsClassName : ''
				}`}
			>
				<ul>
					{titles?.length > 0 &&
						titles.map((title, index) => {
							return (
								<Tab
									name={title}
									key={index}
									index={index}
									activeTab={activeTab}
									changeActiveTab={changeActiveTab}
								/>
							)
						})}
				</ul>
			</div>
			<CSSTransition
				className={`o__tabs-content ${className ? className : ''}`}
				timeout={1200}
				classNames="fade"
				timeout={timeout}
			>
				<div>
					{datas &&
						datas.map((item, index2) => {
							return activeTab === index2 && <div key={index2}>{item}</div>
						})}
				</div>
			</CSSTransition>
		</div>
	)
}
